import { useCallback } from 'react'
import { useSelector } from 'react-redux'

import { changePassword, selectUsers, updateUser } from '@/features/domain/user'
import { useIsUnmounted, useNotification } from '@/hooks'
import { useAppDispatch } from '@/store'

import { useController } from '../../../hooks/useController'
import { useTexts } from './useTexts'

import { ChangePasswordFormValues } from '../../types'

export function useOnSubmit() {
  const texts = useTexts()
  const toast = useNotification()
  const dispatch = useAppDispatch()
  const isUnmounted = useIsUnmounted()
  const {
    update,
    close,
    data: { userId },
  } = useController()
  const users = useSelector(selectUsers)
  const user = users[userId]

  return useCallback(
    async (formValues: ChangePasswordFormValues) => {
      try {
        const result = await dispatch(
          updateUser({
            user,
            password: formValues['new-password'],
          }),
        )

        if (changePassword.rejected.match(result)) {
          const message = result.payload?.message ?? 'Internal error'

          throw new Error(message)
        }

        toast.success(texts.changePasswordSuccess)

        if (isUnmounted()) return

        update({ status: 'ready' })

        close?.()
      } catch (e) {
        update({ status: 'ready' })
        toast.error(e.message)
      }
    },
    [dispatch, isUnmounted, toast, texts, close, update, user],
  )
}
